function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { objectifyParameters, getNewURL, translate, translateFieldName } from '../utils/helpers';

var ShopHeaderFilters = /*#__PURE__*/function (_Component) {
  _inherits(ShopHeaderFilters, _Component);

  var _super = _createSuper(ShopHeaderFilters);

  function ShopHeaderFilters(props) {
    var _this;

    _classCallCheck(this, ShopHeaderFilters);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateOrder", function (order) {
      if (order !== _this.state.order) {
        _this.objectifiedParameters = objectifyParameters(_this.props.match.params);

        _this.setState({
          order: order
        });

        _this.props.history.push(getNewURL(_this.objectifiedParameters, 'order', order, true));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "updatePerPage", function (perPage) {
      if (perPage !== _this.state.perPage) {
        _this.objectifiedParameters = objectifyParameters(_this.props.match.params);

        _this.setState({
          perPage: perPage
        });

        _this.props.history.push(getNewURL(_this.objectifiedParameters, 'display', perPage, true));
      }
    });

    _this.state = {
      perPage: '',
      order: translateFieldName('short_code')
    };
    _this.objectifiedParameters = objectifyParameters(_this.props.match.params);
    return _this;
  }

  _createClass(ShopHeaderFilters, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        perPage: this.objectifiedParameters.display,
        order: this.objectifiedParameters.order
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var pagination = this.props.pagination;
      return /*#__PURE__*/React.createElement("div", {
        className: "row main-item-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-lg-6 results d-none d-sm-none d-md-flex"
      }, /*#__PURE__*/React.createElement("span", {
        className: "results-count"
      }, pagination.total), /*#__PURE__*/React.createElement("span", {
        className: "results-name"
      }, translate('Results', 'Résultats'))), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-lg-6 items-filter"
      }, pagination.total >= 48 ? /*#__PURE__*/React.createElement("div", {
        className: "item-filter main-border"
      }, /*#__PURE__*/React.createElement("span", {
        className: "uppercase"
      }, translate('Display', 'Afficher')), /*#__PURE__*/React.createElement("select", {
        className: "custom-select",
        value: this.state.perPage,
        onChange: function onChange(event) {
          return _this2.updatePerPage(event.target.value);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "48"
      }, translate('48 products', '48 produits')), /*#__PURE__*/React.createElement("option", {
        value: "96"
      }, translate('96 products', '96 produits')))) : null, /*#__PURE__*/React.createElement("div", {
        className: "item-filter main-border"
      }, /*#__PURE__*/React.createElement("span", {
        className: "uppercase"
      }, translate('Order by', 'Classer par')), /*#__PURE__*/React.createElement("select", {
        className: "custom-select",
        value: this.state.order,
        onChange: function onChange(event) {
          return _this2.updateOrder(event.target.value);
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: 'code'
      }, translate('Product code', 'Code produit')), /*#__PURE__*/React.createElement("option", {
        value: 'name'
      }, translate('Product name', 'Nom de produit'))))));
    }
  }]);

  return ShopHeaderFilters;
}(Component);

ShopHeaderFilters.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  pagination: PropTypes.object,
  activeSubSubCategoryName: PropTypes.string
};
export default withRouter(ShopHeaderFilters);